import React, { Component } from 'react';
import { Table, Modal, List, Label } from 'semantic-ui-react';



class UserModalContent extends Component {
  render() {
    const { name, groups } = this.props;
    const stat_new = <Label color='teal' horizontal>New</Label>;
    const stat_pending = <Label color='yellow' horizontal>Pending</Label>;
    const stat_failed = <Label color='red' horizontal>Failed</Label>;
    const stat_process = <Label color='blue' horizontal>Process</Label>;
    const stat_verified = <Label color='green' horizontal>Verified</Label>;

    return (
      <Modal.Content>
        <Table singleLine>
          <Table.Header>
            <Table.Row>
              <Table.HeaderCell>Name : {name}</Table.HeaderCell>
            </Table.Row>
          </Table.Header>

          <Table.Body>
            <Table.Row>
              <Table.Cell>
                <List.List as='ol' className="listGroupState">
                  {groups.map( (data, i) => {
                    let status = '';
                    if (data.groupStatus === 'process') { status= stat_process }
                    else if (data.groupStatus === 'pending') { status = stat_pending }
                    else if (data.groupStatus === 'verified') { status = stat_verified }
                    else if (data.groupStatus === 'failed') { status = stat_failed }
                    else { status = stat_new }
                    return (
                      <List.Item as='li' key={i}> {data.groupName}: {status} </List.Item>
                    );
                  })}
                </List.List>

              </Table.Cell>
            </Table.Row>
          </Table.Body>
        </Table>
      </Modal.Content>
    );
  }
}

export default UserModalContent;



// WEBPACK FOOTER //
// ./src/app/component/Datauser/UserModalContent.js